import {
  GETNOTIFICATIONCONFIGADMIN_SUCCESS,
  GETNOTIFICATIONCONFIGADMIN_FAILED,
  RESET_GETNOTIFICATIONCONFIGADMIN,
  // LOADING_GETNOTIFICATIONCONFIGPARTNER,
  NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetNotificationConfigAdminList = () => {
  return { type: RESET_GETNOTIFICATIONCONFIGADMIN };
};

const getNotificationConfigsAdminList =
  (userData, authTokenIs) => async (dispatch) => {
    // dispatch({ type: LOADING_GETNOTIFICATIONCONFIGPARTNER });
    await adminServices
      .post("getNotificationConfigAdmin", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(getNotificationConfigAdminSuccess(res.data));
            break;
          case "success":
            dispatch(getNotificationConfigAdminSuccess(res.data));
            break;
          default:
            dispatch(getNotificationConfigAdminFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN,
          payload: err,
        });
      });
  };
function getNotificationConfigAdminSuccess(data) {
  return {
    type: GETNOTIFICATIONCONFIGADMIN_SUCCESS,
    payload: data,
  };
}
function getNotificationConfigAdminFailed(data) {
  return {
    type: GETNOTIFICATIONCONFIGADMIN_FAILED,
    payload: data,
  };
}

export { resetGetNotificationConfigAdminList, getNotificationConfigsAdminList };
